/** The distinct reason ids on a selection, in the order they first appear. */
export function distinctReasonIds(items) {
    return [...new Set(items.map((item) => item.reasonId).filter(Boolean))];
}
/**
 * Refund and store credit are only offered when every selected quantity can still be refunded in Shopify:
 * crediting an item that was already refunded would pay for it twice.
 */
export function canRefundSelection(view, items) {
    if (!view.refundable || items.length === 0)
        return false;
    return items.every((selected) => {
        const item = view.items.find((candidate) => candidate.id === selected.lineItemId);
        return item !== undefined && selected.quantity <= item.refundableQuantity;
    });
}
//# sourceMappingURL=api.js.map